import React from 'react';
import { Controls } from 'shared/helper/form';
var checked = function checked(optionValue, selectedValue) {
  var value = Array.isArray(selectedValue) ? selectedValue[0] : selectedValue;
  return optionValue === value;
};
var ControlFromType = function ControlFromType(_ref) {
  var asyncValidateOn = _ref.asyncValidateOn,
    asyncValidators = _ref.asyncValidators,
    defaultValue = _ref.defaultValue,
    description = _ref.description,
    disabled = _ref.disabled,
    label = _ref.label,
    maxLength = _ref.maxLength,
    messages = _ref.messages,
    model = _ref.model,
    name = _ref.name,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    options = _ref.options,
    placeholder = _ref.placeholder,
    required = _ref.required,
    _ref$showToggle = _ref.showToggle,
    showToggle = _ref$showToggle === void 0 ? true : _ref$showToggle,
    _ref$sort = _ref.sort,
    sort = _ref$sort === void 0 ? false : _ref$sort,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    _ref$translate = _ref.translate,
    translate = _ref$translate === void 0 ? {} : _ref$translate,
    type = _ref.type,
    validators = _ref.validators,
    id = _ref.id;
  var FormComponent = Controls[type];
  if (!FormComponent) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FormComponent, {
    asyncValidateOn: asyncValidateOn,
    asyncValidators: asyncValidators,
    checked: checked,
    defaultValue: defaultValue,
    description: description,
    disabled: disabled,
    label: label,
    maxLength: maxLength,
    messages: messages,
    model: model,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    options: options,
    placeholder: placeholder,
    required: required,
    showToggle: showToggle,
    sort: sort,
    styles: styles,
    translate: translate,
    validators: validators,
    id: id
  });
};
export default ControlFromType;